const Loader = () => {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "#f5f5f5"
      }}>
        <div className="spinner" />
        <style>
          {`
            .spinner {
              width: 50px;
              height: 50px;
              border: 6px solid #ddd;
              border-top: 6px solid #c6001a;
              border-radius: 50%;
              animation: spin 1s linear infinite;
            }
  
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  };
  
  export default Loader;
  